var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10316 12.5902C3.83654 12.6007 2.80305 11.5843 2.79251 10.3176C2.78197 9.05103 3.7984 8.01753 5.06502 8.00699C6.33165 7.99645 7.36514 9.01289 7.37568 10.2795C7.38622 11.5461 6.36979 12.5796 5.10316 12.5902ZM5.07543 9.25695C4.50045 9.26173 4.03768 9.73227 4.04246 10.3072C4.04725 10.8822 4.51778 11.345 5.09276 11.3402C5.66774 11.3354 6.13051 10.8649 6.12572 10.2899C6.12094 9.71493 5.65041 9.25216 5.07543 9.25695Z",
    fill: "#9186A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7694 12.4931C15.5028 12.5036 14.4693 11.4872 14.4588 10.2206C14.4482 8.95395 15.4647 7.92046 16.7313 7.90992C17.9979 7.89938 19.0314 8.91581 19.0419 10.1824C19.0525 11.4491 18.036 12.4826 16.7694 12.4931ZM16.7417 9.15987C16.1667 9.16466 15.7039 9.63519 15.7087 10.2102C15.7135 10.7852 16.184 11.2479 16.759 11.2431C17.334 11.2383 17.7968 10.7678 17.792 10.1928C17.7872 9.61786 17.3167 9.15509 16.7417 9.15987Z",
    fill: "#9186A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9363 12.5416C9.66967 12.5522 8.63618 11.5357 8.62564 10.2691C8.6151 9.00247 9.63153 7.96898 10.8982 7.95844C12.1648 7.9479 13.1983 8.96433 13.2088 10.231C13.2194 11.4976 12.2029 12.5311 10.9363 12.5416ZM10.9086 9.2084C10.3336 9.21318 9.87081 9.68371 9.87559 10.2587C9.88038 10.8337 10.3509 11.2964 10.9259 11.2917C11.5009 11.2869 11.9636 10.8163 11.9589 10.2414C11.9541 9.66638 11.4835 9.20361 10.9086 9.2084Z",
    fill: "#9186A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more_icon.c9119b4aa5cf4305cef20dbdffb8b81b.svg";
export { ForwardRef as ReactComponent };